import React, { useCallback, FC } from 'react'
import { useTheme } from '@mui/material/styles'
import { useDispatch, useStore } from 'react-redux'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'

import routerActions from '../../store/modules/router'
import FAIcon from './FAIcon'

import {
  MenuItem,
} from '../../types/app'

import {
  FC_DRAWER_ICON_SIZE,
} from '@kaidam/fc-shared/src/constants/mui'

interface MenuListProps {
  items: MenuItem[],
  withTooltip?: boolean,
  onClick: {
    (item: MenuItem): void,
  },
}

const MenuList: FC<React.PropsWithChildren<MenuListProps>> = ({
  items,
  withTooltip,
  onClick,
}) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const store = useStore()


  const clickItem = useCallback((item: MenuItem) => {
    if(item.link) {
      dispatch(routerActions.navigateTo(item.link, item.params || {}))
    }
    else if(item.handler) {
      item.handler(dispatch, store.getState)
    }
    if(onClick) onClick(item)
  }, [])

  return (
    <Box
      sx={{
        height: '100%',
        overflowY: '',
        overflowX: 'hidden',
      }}
    >
      <List
        component="nav"
      >
      {
        items.map((item: MenuItem, i) => {
          if(item.title === '-') {
            return (
              <Divider
                sx={{
                  p: 0.5,
                  mb: 0.5,
                }}
                  key={ i }
                />
              )
            }

            let iconElement = null

            if(typeof(item.icon) == 'string') {
              iconElement = (
                <FAIcon
                  iconName={ item.icon as string }
                  iconSx={{
                    p: 0,
                    mx: 0,
                    my: 0.1,
                    minHeight: FC_DRAWER_ICON_SIZE,
                    color: 'primary.main',
                  }}
                />
              ) 
            } else if(item.icon) {
              iconElement = (
                <item.icon />
              )
            }

            return (
              <ListItem 
                button 
                key={ i }
                sx={{
                  px: 0,
                  pt: 0.2,
                  pb: 0.2,
                  m: 0,
                }}
                onClick={ () => clickItem(item) }
              >
                {
                  item.icon && (
                    <ListItemIcon
                      className='menu-icon'
                      sx={{
                        m: 0,
                        p: 0,
                        pl: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      { iconElement }
                    </ListItemIcon>
                  )
                }
                <ListItemText
                  primary={ item.title }
                  primaryTypographyProps={{
                    sx: {
                      color: '#333',
                    }
                  }}
                  sx={{
                    pl: 2,
                  }}
                />
              </ListItem>
            )
          })
        }
      </List>
    </Box>
  )
}

export default MenuList